import EnumService from '../EnumService'

export default class FormaPagamentoEnumService extends EnumService{

    constructor(){
        super('enumFormaPagamento');
    }
  
  }